export default {
  title: 'Testmålgruppe',
  columns: {
    id: 'ID',
    phone_number: 'Telefonnummer',
  },
  filters: {
    search: {
      placeholder: 'Søg',
    },
  },
  buttons: {
    send_test: 'Send test',
  },
  feedback: {
    success: 'Sendt',
    error: 'Kunne ikke sendes',
  },
};
